module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-regular.0ad032b3.woff2";